import { DOWNLOAD_DOCUMENT } from './actionTypes';

export const downloadDocument = (fileId, source, fileName) => ({
  type: DOWNLOAD_DOCUMENT,
  fileId,
  source,
  fileName,
});
